import { render, staticRenderFns } from "./LeaveButton.vue?vue&type=template&id=4cef835a&lang=pug"
import script from "./LeaveButton.vue?vue&type=script&lang=ts"
export * from "./LeaveButton.vue?vue&type=script&lang=ts"
import style0 from "./LeaveButton.vue?vue&type=style&index=0&id=4cef835a&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports